import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"

export const useUploadLogo = (
  options?: UseMutationOptions<string, Error, File>
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData()
      formData.append("file", file)
      const response = await httpClient.post(
        "/v1/organization-settings/upload-logo",
        formData
      )
      return response.data
    },
    ...options,
  })
}
